import { useNavigate } from "react-router-dom";
import { Button } from "risa-oasis-ui_v2";

import { SubmissionStatusEnum } from "../../../../data-model/submissionDocs";
import { GreenTickIcon } from "../../../../svg/green-tick-icon";
import { RedCrossIcon } from "../../../../svg/red-cross-icon";

import { LocalStorageKeys } from "../../../../enums/localStorageKeys";
import SubmissionInitiatedIcon from "../../../../svg/submissionInitiated";
import WarningIcon from "../../../../svg/warningIcon";
import { getItemFromLocalStorage } from "../../../../utils/localStorageHelper";
import "./statusComponent.scss";

interface StatusComponentProps {
  status?: SubmissionStatusEnum;
}

const StatusComponent = (props: StatusComponentProps) => {
  const navigate = useNavigate();

  const getIconBasedOnStatus = () => {
    switch (props.status) {
      case "initiated":
        return <SubmissionInitiatedIcon height="48" width="48" />;
      case "in_progress":
        return <SubmissionInitiatedIcon height="48" width="48" />;
      case "completed":
        return <GreenTickIcon height="48" width="48" />;
      case "error":
        return <RedCrossIcon height="48" width="48" />;
      default:
        return <WarningIcon height="48" width="48" />;
    }
  };

  const returnToOrder = () => {
    const getParentTable = getItemFromLocalStorage(
      LocalStorageKeys.PARENT_TABLE,
    );
    if (getParentTable) {
      navigate(`/worklists/${getParentTable}`);
    } else {
      navigate(`/worklists/`);
    }
  };

  const getStatusText = () => {
    switch (props.status) {
      case "initiated":
        return "Initiated!";
      case "in_progress":
        return "In Progress";
      case "completed":
        return "Successfull";
      case "error":
        return "Something went wrong";
      default:
        return "Auth not required";
    }
  };

  const getSubTextBasedOnStatus = () => {
    switch (props.status) {
      case "initiated":
        return "Authorization is in progress and will take 5-10 minutes. Track the status in the 'PA Status' tab";
      case "in_progress":
        return "Submission is in progress and will take 5-10 minutes. \nPlease check back later.";
      case "completed":
        return "Prior Auth has been submitted to the payor";
      case "error":
        return (
          <>
            Contact administrator or mail at{" "}
            <span className="text-small font-semiBold text-tertiaryBlue-4">
              mail@risa.health
            </span>{" "}
            for further assistance
          </>
        );
      default:
        return "Authorization is not required for the following CPT code";
    }
  };

  return (
    <div className="status-component--container flex w-80 flex-col items-center justify-center gap-2">
      <div className="status-container--icon">{getIconBasedOnStatus()}</div>
      <div className="status-container--statu-text text-h10 font-bold text-primaryGray-1">
        {getStatusText()}
      </div>
      <div className="status-container--text text-center text-small font-regular leading-5 text-primaryGray-4">
        {getSubTextBasedOnStatus()}
      </div>
      <div className="status-container--action-btn mt-2 self-stretch">
        <Button
          disabled={false}
          children={"Go Back to Orders"}
          onClick={returnToOrder}
          buttonType={"primary"}
          size={"medium"}
        />
      </div>
    </div>
  );
};

export default StatusComponent;
